<template>
  <div class="shooting">
    <div class="container" :class="{active: !loading}" v-if="!loadingQuery">
      <template v-if="post">
        <header>
          <span>Shooting | {{ post.date | dateFormat }}</span>
          <h1>{{ post.title }}</h1>
          <div class="model" v-if="post.acf_shooting.modelsShooting">
            <LinkInstagram v-for="({ fullname, pseudoInstagram })  in post.acf_shooting.modelsShooting" 
            :key="fullname"
            :pseudo="pseudoInstagram"
            :name="fullname"/>
          </div>
          <div class="content" v-html="post.content"></div>
        </header>
        <transition name="fade">
          <Loading :progress="progress" v-if="loading"/>
        </transition>
        <div class="gallery" v-images-loaded:on.progress="imageProgress">
          <DisplayImage v-for="({ sourceUrl, srcSet, altText, categories }, i) in post.acf_shooting.galleryShooting"
            :key="i"
            :src="sourceUrl"
            :srcset="srcSet"
            :alt="altText"
            :legend="categories.nodes.map(({name}) => name).join(' | ')"
            :active="!loading"/>
        </div>
        <div class="contact">
          <span>Wanna know more ?</span>
          <p><router-link to="/contact">Contact me</router-link></p>
        </div>
      </template>
      <template v-else>
        <header class="active">
          <span>This category does not exist</span>
          <h1>404 Error</h1>
        </header>
      </template>
    </div>
  </div>
</template>

<script>
import { useQuery, useResult } from '@vue/apollo-composable'
import { SHOOTING } from '../queries'

import DisplayImage from '../components/DisplayImage'
import LinkInstagram from '../components/LinkInstagram'
import Loading from '../components/Loading'

import { useImageLoading } from '../compositions/useImageLoading'
import { computed } from '@vue/composition-api'

export default {
  name: 'Category',
  components: {
    Loading,
    DisplayImage,
    LinkInstagram
  },
  head: {
    title() {
      return {
        inner: this.title
      }
    },
  },
  setup(props, { root: { $route } }) {
    let { id } = $route.params
    const title = computed(() => id.toUpperCase().replace(/-/g, ' '))

    const { result, loading: loadingQuery } = useQuery(SHOOTING, { id })
    const post = useResult(result, null, data => data.post)

    const [ progress, loading, imageProgress ] = useImageLoading()

    return {
      title,
      progress, 
      loading, 
      imageProgress,
      loadingQuery,
      post
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    @extend %container;

    margin-top: 8rem;
  }

  span {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.3rem;
    transition: opacity 0.8s $ease-out, letter-spacing 1s $ease-out;
    opacity: 0;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  h1 {
    @extend %font-bold;

    font-size: 3rem;
    line-height: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0;
    color: $red;
      
    letter-spacing: 0.5rem;
    transition: opacity 0.8s 0.4s $ease-out, letter-spacing 1s 0.4s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }

  .model,
  .content  {
    opacity: 0;

    .active & {
      opacity: 1;
    }
  }

  .content {
    transition: opacity 0.8s 1s $ease-out;
  }

  .model {
    position: relative;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    transition: opacity 0.8s 0.7s $ease-out;

    &:before {
      position: absolute;
      content: "";
      bottom: 0;
      left: 0;
      width: 2rem;
      height: 1px;
      background-color: lighten($black, 50%);
    }
  }

  .contact {
    text-align: center;
    
    p {
      @extend %font-bold;
      opacity: 0;
      transition: opacity 0.8s $ease-out;

      .active & {
        opacity: 1;
      }
    }
  }
</style>